import React from 'react';
import { useSelector } from 'react-redux';
import ListItemNavLink from '../ListItemNavLink';
import { getMembersRoute } from '../../../../router/routes/artist/factory/members';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import FaceIcon from '@mui/icons-material/Face';
import { getArtistRoute } from '../../../../router/routes/artist/factory/artist';
import { List } from '@mui/material';
import { useTranslation } from 'react-i18next';

const MenuArtist = () => {
	const { t } = useTranslation();

	const selectedRealm = useSelector(state => state.realm.selected);
	const ready = useSelector(state => state.common.ready);
	const artist = useSelector(state => state.artist.artist);

	const disabled = !selectedRealm || !ready || !artist;

	return (
		<List>
			<ListItemNavLink
				tooltip={t('menu_artist')}
				path={getArtistRoute()}
				exact={true}
				icon={<FaceIcon />}
				primary={t('menu_artist')}
				disabled={disabled}
			/>
			<ListItemNavLink
				tooltip={t('menu_artist_members')}
				path={getMembersRoute()}
				exact={true}
				icon={<PeopleAltIcon />}
				primary={t('menu_artist_members')}
				disabled={disabled}
			/>
		</List>
	);
};

export default MenuArtist;
